import LoginButton from "@/modules/login-button";

import "./login-page.style.less";

export const LoginPage = () => {
  return (
    <div className="login-page">
      <LoginButton type="primary" size="large" />
    </div>
  );
};

export default LoginPage;
